/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Preview_Lock_TitleInputs */



/**
* | output |
* | --- |
* | "Preview CC" |
*
* @param {Player_Preview_Lock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_preview_lock_title = /** @type {((inputs?: Player_Preview_Lock_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Preview_Lock_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu des CC")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau CC")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima CC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр CC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa CC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览 CC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューCC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन सीसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização CC")
	return /** @type {LocalizedString} */ ("Preview CC")
});